require('angular-material/angular-material.css');
require('materialize-css/dist/css/materialize.css');
require('animate.css/animate.css');
require('angular-timeline/dist/angular-timeline.css');
require('./main.scss');



// WEBPACK FOOTER //
// ./src/app/styles/index.js